import { useParams } from "react-router-dom";

import { LoadingState } from "~/common/components";
import { ConsultationCompleted } from "~/patients/components/consultations/shared";
import {
  useGetCurrentIntakeBundle,
  useGetCurrentPatient,
} from "~/patients/hooks";
import { useCompleteIntake } from "~/patients/hooks/queries/consultations/intake/useCompleteIntake";

interface ScreeningCompletedScreenProps {
  handleGoBackFinalScreen: () => void;
  isNavigatingBack: boolean;
}
export const IntakeCompletedScreen = ({
  handleGoBackFinalScreen,
  isNavigatingBack,
}: ScreeningCompletedScreenProps) => {
  const { data: user } = useGetCurrentPatient();
  const consultationId = user?.consultation?.id;

  const { id: patientIntakeId } = useParams();
  const { completeIntakeMutation, isPending } = useCompleteIntake();
  const { data, isLoading, isFetching } = useGetCurrentIntakeBundle();

  if (!data) return;

  const { sections_completed, total_sections } = data;
  const sectionCompleted = (sections_completed ?? 0) + 1;
  const isFinalIntake = sectionCompleted === total_sections;

  const title = `You’ve completed Section ${sectionCompleted}!`;

  const subtitle = isFinalIntake
    ? "You can’t edit your answers once you submit and continue."
    : "You can’t edit your answers once you move to the next section.";

  const continueLabel = isFinalIntake
    ? "Submit and continue"
    : "Continue to next section";

  const handleCompleteIntake = () =>
    patientIntakeId &&
    completeIntakeMutation({ id: patientIntakeId, consultationId });

  if (isFetching) return <LoadingState />;

  return (
    <ConsultationCompleted
      handleGoBackFinalScreen={handleGoBackFinalScreen}
      isNavigatingBack={isNavigatingBack}
      title={title}
      subtitle={subtitle}
      isLoading={isLoading}
      isPending={isPending}
      handleComplete={handleCompleteIntake}
      continueLabel={continueLabel}
    />
  );
};
